import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
} from "@nebular/auth";
import { AuthGuard } from "./shared/services/auth/auth.guard";
import { ResetPassComponent } from "./pages/reset-pass/reset-pass.component";
import { ForgotPwdComponent } from "./pages/forgot-pwd/forgot-pwd.component";
import { LoginComponent } from "./pages/login/login.component";
import { RegisterComponent } from "./pages/register/register.component";
import { RedirectComponent } from "./pages/redirect/redirect.component";

export const routes: Routes = [
  {
    path: "pages",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
  },
  {
    path: "auth",
    component: NbAuthComponent,
    children: [
      {
        path: "",
        component: LoginComponent,
      },
      {
        path: "login",
        component: LoginComponent,
      },
      {
        path: "register/:token",
        component: RegisterComponent,
      },
      {
        path: "logout",
        component: NbLogoutComponent,
      },
      {
        path: "request-password",
        component: ForgotPwdComponent,
      },
      {
        path: "reset-pass/:token/:email",
        component: ResetPassComponent,
      },
    ],
  },
  { path: "redirect", component: RedirectComponent },

  { path: "", redirectTo: "pages", pathMatch: "full" },
  { path: "**", redirectTo: "pages" },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
